import { fileApi } from './fileApi.js'

export const baseServer = {
  ...fileApi,
}
